<template>
  <v-container class="pt-3">
    <v-layout row wrap>
      <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2>
        <h3 class="headline mt-0 mb-3">Mitwirkende <strong>Kreishandwerkerschaften</strong></h3>
        <v-layout row wrap>
          <div v-for="kh in this.khs" :key="kh.id">
              <div class="text-truncate" v-if="kh.slug">
                <v-btn large dark color="light-blue darken-4" :to="{ name: 'khdetail', params: { id: kh.slug } }">
                  <h3 class="subheading text-none font-weight-medium">
                    {{ kh.name.substr(22) }}
                  </h3>
                </v-btn>
              </div>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
  

<script>

export default {
  props: ['khs']
}
</script>

<style>
</style>